// extracted by mini-css-extract-plugin
module.exports = {"iconWrapper":"cTWLggq6","mainLabel":"gNnAWYm8","itemBackground":"OdUaDnw6","subItem":"o07IGeIg","sideBarExpanded":"nTgpGeLc","isActive":"Je1Bcmvm"};